import React, { useEffect, useState } from "react";
import Restaurant from "./Restaurant";
import Home from "./Home";
import useUserStore from "../stores/store";

export default function CommonDashboard({}) {
  const isSuperAdmin = useUserStore((s) => s.isSuperAdmin);

  if (isSuperAdmin) {
    return <Restaurant />
  }

  return <Home />
}